"use client";

import React from "react";
import BusinessSectionBlock from "./BusinessSectionBlock";
import rumah from "../../assets/daycare-new.jpeg";

export default function BusinessSectionDaycare() {
  return (
    <BusinessSectionBlock
      title="Start exploring Daycare"
      description="Our daycare service is designed to support the comfort of the academic community and the public by providing a safe, nurturing, and educational environment for children. Managed by trained professionals, we ensure each child receives attentive care and engaging activities that support their growth and development. Featuring a Montessori-based curriculum, our daycare provides a high-quality early learning experience you can trust."
      image={rumah}
      href="/daycare"
      reverse={true}
    />
  );
}